import React, { Fragment, useEffect, useState } from 'react';

// Components
import CustomFieldHeader from './CustomFieldHeader';
import CustomFieldList from './CustomFieldList';
import CustomFieldModal from '../modals/CustomFieldModal';

// Hooks
import { useCustomFields, useDisclosure } from '@hooks/index';

import {
    CUSTOM_FIELD_FORM_NAMES,
    CUSTOM_TYPE_OPTIONS
} from '../forms/ticketFormConfigs';


interface ICustomTypeOption {
    value: string;
    text: string;
}

interface ICustomData {
    className: string;
    headerText: string;
    submitBtnText: string;
    initialFormValues: {};
    addCustomFields?: (data: any) => void;
    onClose: () => void;
    isEdit: boolean;
    customTypeOptions: Array<ICustomTypeOption>;
}

interface IIdValue {
    id: string | number | null | undefined;
    value: string | number | null | undefined;
}

const CustomFieldManagement = () => {

    const { customFields=[], customField, postSuccess, isDuplicate, getCustomFields, postCustomFields, putCustomFields, getCustomFieldById, resetAll } = useCustomFields();
    const { isOpen: isOpenCustomModal, onOpen: openCustomModal, onClose: closeCustomModal } = useDisclosure();
    const [customData, setCustomData] = useState<ICustomData | null>(null);

    useEffect(() => {
        getCustomFields();
    },[]);

    useEffect(() => {
        if(customField.id){
            let optionValues: any[] = [];
            resetAll();
            if ( customField.optionValues ){
                Object.getOwnPropertyNames(customField.optionValues ).forEach(function(key) {
                    optionValues.push( customField.optionValues [key] );
                });
            }
            const INITIAL_CUSTOM_FIELD_FORM_VALUES = {
                [CUSTOM_FIELD_FORM_NAMES.NAME]: customField.name,
                [CUSTOM_FIELD_FORM_NAMES.TYPE]: customField.type,
                [CUSTOM_FIELD_FORM_NAMES.DESCRIPTION]: customField.description,
                [CUSTOM_FIELD_FORM_NAMES.LIST]: optionValues.length > 0 ? optionValues.join('\r\n'): '',    
            };
            const data = {
                className: 'ticket_management',
                headerText: 'ticket_management.edit_custom_field',
                initialFormValues: INITIAL_CUSTOM_FIELD_FORM_VALUES,
                updateCustomFields:updateCustomFields,
                onClose:closeCustomModal,
                submitBtnText:'ticket_management.custom_field.update_btn',
                isEdit: true,
                customTypeOptions: CUSTOM_TYPE_OPTIONS
            };
            setCustomData(data);
            openCustomModal();
        }
    },[customField]);

    useEffect(() => {
        if(postSuccess)
            closeCustomModal();
    },[postSuccess]);

    const addCustomFields = (data) => {
        postCustomFields(data);
    };

    const prepareData = (data) => {
        let updatedData: IIdValue[] = [];
        data.forEach(function(val) {
            updatedData.push({ 'id': null, 'value': val });
        });
        
        return updatedData;
    };

    const updateCustomFields = (data) => {

        if(data.type === CUSTOM_TYPE_OPTIONS[1].value){
            const updatedData = prepareData(data.values);
            delete data['values'];
            data.customFieldValuesDto = updatedData;
        }
        data.id = customField.id;
        
        putCustomFields(data);
    };

    const getCustomField = (id) => {
        getCustomFieldById(id);
    };

    const openCustomFieldModal = () => {

        resetAll();

        const INITIAL_CUSTOM_FIELD_FORM_VALUES = {
            [CUSTOM_FIELD_FORM_NAMES.NAME]: '',
            [CUSTOM_FIELD_FORM_NAMES.TYPE]: CUSTOM_TYPE_OPTIONS[1].value,
            [CUSTOM_FIELD_FORM_NAMES.LIST]: '',   
            [CUSTOM_FIELD_FORM_NAMES.DESCRIPTION]: '' 
        };
        const data = {
            className: 'ticket_management',
            headerText: 'ticket_management.add_custom_field',
            submitBtnText:'ticket_management.custom_field.add_btn',
            initialFormValues: INITIAL_CUSTOM_FIELD_FORM_VALUES,
            addCustomFields:addCustomFields,
            onClose:closeCustomModal,
            isEdit: false,
            customTypeOptions: CUSTOM_TYPE_OPTIONS
        };    
        setCustomData(data);
        openCustomModal();
    };

    return (
        <Fragment>
            <div className="gi-panel">
                <CustomFieldHeader
                    { ...{
                        openCustomFieldModal
                    } }
                />
                <CustomFieldList
                    { ...{
                        openCustomFieldModal,
                        getCustomField,
                        customFields
                    } }
                />
                {
                    isOpenCustomModal &&
                    <CustomFieldModal modalData={customData} isDuplicate={isDuplicate}/>
                }
            </div>
        </Fragment>
    );
};

export default CustomFieldManagement;